<template>
  <CRow class="balances pt-1 align-content-start" :gutters="false">
    <CCol sm="12" class="balances__item mb-1 px-2" v-for="(ItemBalance, index) in handlerBalances" :key="`${ItemBalance.channel}-${index}`">
      <div class="d-flex justify-content-between flex-row align-content-center p-2">
        <div class="font-base">
          <img :src="getFlag(ItemBalance.countryId).flag" width="25" height="auto" class="mr-2" />
          {{ getFlag(ItemBalance.countryId).label }}
        </div>

        <p class="m-0 font-base">
          {{ numberWithCommas(ItemBalance.balance) }}
        </p>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import { nameCountries } from '@/utils/countriesUtils.js'
const channelTypeCode = {
  1: 'email',
  2: 'sms',
}

export default {
  name: 'BalanceCountry',
  props: {
    balances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      channelTypeCode,
    }
  },

  computed: {
    handlerBalances() {
      const ARR = JSON.parse(JSON.stringify(this.balances)) || []
      return ARR.length && ARR.sort((a, b) => b.balance - a.balance)
    },
  },

  methods: {
    getFlag(data) {
      const item = nameCountries(this).filter((item) => item.value.toUpperCase() == data.toUpperCase())
      if (item[0]) {
        return { ...item[0] }
      }
      return ''
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    covertUppercase(text) {
      return text ?? text.toUpperCase()
    },
  },
}
</script>

<style lang="scss" scoped>
.balances {
  max-height: 250px;
  overflow-y: scroll;
  &__item {
    height: 40px;
  }
}
</style>
